import { Controller } from "@hotwired/stimulus"
import ApexCharts from "apexcharts"
import { brl } from "../../lib/utils"

// Connects to data-controller="graphs--cost-center-pie"
export default class extends Controller {
  static values = {
    data: Object,
    tone: String
  }

  connect() {
    this.labels = this.dataValue.labels || []
    this.legendLabels = this.labels.map((label) => this.truncateLabel(label))
    this.externalLabels = this.labels.map((label) => this.truncateLabel(label, 12))
    this.series = this.dataValue.series || []

    if (!this.hasRenderableData()) {
      this.element.innerHTML = `
        <div class="flex items-center justify-center h-full text-base-content/60 text-sm">
          Sem dados para exibir
        </div>
      `
      return
    }

    this.chart = new ApexCharts(this.element, {
      chart: {
        type: "donut",
        height: "100%",
        width: "100%",
        toolbar: { show: false },
        fontFamily: "inherit",
        parentHeightOffset: 0,
      },
      theme: {
        monochrome: {
          enabled: true,
          color: this.toneValue === "success" ? "#009966" : "#fb2c36",
        },
      },      
      labels: this.externalLabels,
      series: this.series,
      stroke: {
        colors: ["var(--color-base-100)"],
        width: 2,
      },
      legend: this.legendOptions,
      plotOptions: {
        pie: {
          dataLabels: {
            minAngleToShowLabel: 20,
            external: {              
              show: true,
              color: "var(--color-base-content)",
              formatter: (name, { percent }) => {
                if (percent < 4) return ""
                return name
              }              
            },
          },          
        },
      },
      dataLabels: {
        enabled: true,
        style: {
          fontSize: "0.65rem",
          
        }  
      },
      tooltip: {
        custom: ({ seriesIndex, w }) => {
          const percentage = `${w.globals.seriesPercent[seriesIndex][0].toFixed(1)}%`;
          const label = this.labels[seriesIndex]
          const amount = brl.format((this.series[seriesIndex] || 0) / 100)
          const amountColor = this.toneValue === "success" ? "var(--color-success)" : "var(--color-error)"
          return `<div class="py-2 text-xs bg-base-100 border text-base-content rounded-box shadow-2xl">
            <div class="font-semibold mb-2 border-b px-4 pb-2">${label}</div>
            <div class="flex flex-col gap-2 px-4 font-medium">
              <span>${percentage}</span>
            </div>
          </div>`
        },
      },
      responsive: [{
        breakpoint: 640,
        options: {
          legend: this.legendOptions,
        },
      }],
    })

    this.chart.render()
  }

  hasRenderableData() {
    return this.series.some((value) => {
      const amountCents = Number(value)

      return Number.isFinite(amountCents) && amountCents > 0
    })
  }

  truncateLabel(label, maxLength = 18) {
    if (label.length <= maxLength) return label

    return `${label.slice(0, maxLength - 1)}...`
  }

  get legendOptions() {
    return {
      show: true,
      position: "bottom",
      fontSize: "12px",
      markers: { size: 7 },
      formatter: (_seriesName, opts) => {
        return this.legendLabels[opts.seriesIndex] || ""
      },
      labels: {
        colors: "var(--color-base-content)",
      },
    }
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }
}
